export const enum AppRootEnum {
    app = "app",
    standalone = "standalone",
    sharedComponents = "sharedcomponents",
}
